import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AretiSectionState {
  isAretiSectionVisible: boolean;
  isChatbotLoaded: boolean;
}

const initialState: AretiSectionState = {
  isAretiSectionVisible: false,
  isChatbotLoaded: false,
};

const aretiSectionSlice = createSlice({
  name: 'aretiSection',
  initialState,
  reducers: {
    setAretiSectionVisible: (state, action: PayloadAction<boolean>) => {
      state.isAretiSectionVisible = action.payload;
    },
    setAretiChatbotLoaded: (state, action: PayloadAction<boolean>) => {
      state.isChatbotLoaded = action.payload;
    },
  },
});

export const { setAretiSectionVisible, setAretiChatbotLoaded } = aretiSectionSlice.actions;
export default aretiSectionSlice.reducer;
